import { theme, darkTheme } from './theme/themeVariables';
import { getItem } from '@/util/localStorage';

const config = {
  darkMode: getItem('darkMode'),
  topMenu: false,
  rtl: false,
  theme,
  darkTheme,
  auth0: false,
};

export default config;
